<template>
    <div class="contactMe d_flex_col center" id="contactMe">
        <h2 v-scroll-reveal.reset>
            Send Me A
            <span class="change_color">Message</span>
        </h2>
        <div class="container">
            <form @submit.prevent="submitForm" ref="contactForm">
                <div class="d_flex inputs_flex space_between">
                    <div class="input_wrapper mb_3_sm">
                        <InputField
                            :label="'Name'"
                            @highlighted="highlighted"
                            :identifier="identifier"
                            :placeholder="'Enter your name'"
                            :value="formData.name"
                            @input="updateField('name', $event)"
                            :required="true"
                        />
                    </div>
                    <div class="input_wrapper">
                        <InputField
                            :label="'Email Address'"
                            @highlighted="highlighted"
                            :identifier="identifier"
                            :placeholder="'Enter your Email Address'"
                            :value="formData.email"
                            @input="updateField('email', $event)"
                            :required="true"
                            type="email"
                        />
                    </div>
                </div>
                <div>
                    <InputField
                        :label="'Message'"
                        @highlighted="highlighted"
                        :identifier="identifier"
                        :placeholder="'You have something you would like to discuss with me? Enter your message here.'"
                        :value="formData.message"
                        @input="updateField('message', $event)"
                        :required="true"
                        textArea
                    />
                </div>

                <div class="button_wrapper" v-scroll-reveal.reset="{ delay: 300 }">
                    <button type="submit" class="contact_btn" :disabled="isSubmitting">
                        <span v-if="!isSubmitting">Send</span>
                        <span v-else>Sending...</span>
                        <span v-if="!isSubmitting">
                            <i class="fas fa-long-arrow-alt-right"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-spinner fa-spin"></i>
                        </span>
                    </button>
                </div>
            </form>

            <!-- Success/Error Messages -->
            <div v-if="message" class="message" :class="messageType">
                {{ message }}
            </div>
        </div>

        <div class="d_flex space_between align_center social_icons">
            <a href="https://github.com/mrkeyiano">
                <svg width="28px" height="28" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g fill="white">
                        <path
                            d="M24.0002 0C10.747 0 0 11.0169 0 24.6076C0 35.4799 6.87679 44.7039 16.4128 47.9577C17.6123 48.1855 18.0526 47.4239 18.0526 46.7739C18.0526 46.1872 18.0304 44.2487 18.02 42.1925C11.3431 43.6811 9.93424 39.2891 9.93424 39.2891C8.84249 36.4448 7.26945 35.6885 7.26945 35.6885C5.09192 34.1613 7.43359 34.1926 7.43359 34.1926C9.84363 34.3662 11.1126 36.7285 11.1126 36.7285C13.2532 40.4904 16.7272 39.4028 18.0967 38.7741C18.3121 37.1836 18.9341 36.0981 19.6205 35.4836C14.2897 34.8613 8.6859 32.7513 8.6859 23.3224C8.6859 20.6358 9.62345 18.4406 11.1587 16.7174C10.9095 16.0976 10.088 13.5947 11.3912 10.2052C11.3912 10.2052 13.4066 9.54387 17.993 12.7276C19.9074 12.1824 21.9606 11.9089 24.0002 11.8996C26.0398 11.9089 28.0946 12.1824 30.0126 12.7276C34.5934 9.54387 36.606 10.2052 36.606 10.2052C37.9123 13.5947 37.0905 16.0976 36.8413 16.7174C38.3801 18.4406 39.3113 20.6358 39.3113 23.3224C39.3113 32.7738 33.6968 34.8548 28.3525 35.464C29.2133 36.2276 29.9804 37.7252 29.9804 40.021C29.9804 43.3135 29.9526 45.9634 29.9526 46.7739C29.9526 47.4288 30.3846 48.1961 31.6011 47.9544C41.132 44.697 48 35.4762 48 24.6076C48 11.0169 37.2546 0 24.0002 0Z"
                        />
                        <path
                            d="M9.16085 35.1623C9.10809 35.2833 8.92085 35.3196 8.75027 35.2365C8.57652 35.157 8.47893 34.992 8.53526 34.8706C8.58683 34.7459 8.77447 34.7112 8.94782 34.7947C9.12197 34.8742 9.22115 35.0408 9.16085 35.1623Z"
                        />
                        <path
                            d="M10.1312 36.263C10.0169 36.3707 9.79358 36.3207 9.64205 36.1504C9.48535 35.9806 9.456 35.7534 9.57183 35.6441C9.68965 35.5363 9.90624 35.5868 10.0633 35.7566C10.22 35.9285 10.2506 36.1541 10.1312 36.263Z"
                        />
                        <path
                            d="M11.0757 37.6663C10.9289 37.77 10.6889 37.6728 10.5406 37.4561C10.3938 37.2394 10.3938 36.9796 10.5437 36.8755C10.6925 36.7714 10.9289 36.865 11.0793 37.0801C11.2257 37.3004 11.2257 37.5602 11.0757 37.6663Z"
                        />
                        <path
                            d="M12.3697 39.0219C12.2384 39.1692 11.9588 39.1297 11.7541 38.9287C11.5446 38.7322 11.4863 38.4534 11.618 38.3062C11.7509 38.1585 12.0321 38.2001 12.2384 38.3994C12.4463 38.5955 12.5098 38.8763 12.3697 39.0219Z"
                        />
                        <path
                            d="M14.1548 39.8091C14.0969 40 13.8276 40.0867 13.5562 40.0056C13.2853 39.9221 13.108 39.6986 13.1627 39.5057C13.219 39.3137 13.4896 39.2233 13.7629 39.31C14.0334 39.3932 14.2112 39.6151 14.1548 39.8091Z"
                        />
                        <path
                            d="M16.1153 39.9552C16.122 40.1561 15.892 40.3228 15.6071 40.3264C15.3207 40.3329 15.089 40.1703 15.0859 39.9726C15.0859 39.7696 15.3108 39.6046 15.5972 39.5998C15.882 39.5941 16.1153 39.7555 16.1153 39.9552Z"
                        />
                        <path
                            d="M17.9397 39.6392C17.9738 39.8353 17.7759 40.0366 17.493 40.0903C17.2149 40.1419 16.9575 40.0209 16.9222 39.8264C16.8877 39.6255 17.0892 39.4241 17.3669 39.3721C17.6501 39.3221 17.9036 39.4399 17.9397 39.6392Z"
                        />
                    </g>
                </svg>
            </a>

            <a href="https://twitter.com/usecodeninja">
                <svg width="19" height="15" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.2812 5.50752L11.3316 6.33798L10.4922 6.23629C7.43686 5.84649 4.76765 4.52454 2.50134 2.30434L1.39336 1.20272L1.10798 2.01623C0.503625 3.82967 0.889738 5.7448 2.1488 7.03285C2.8203 7.74467 2.66921 7.84636 1.51088 7.42265C1.10798 7.28707 0.755438 7.18538 0.721863 7.23623C0.60435 7.35486 1.00725 8.89713 1.32621 9.50726C1.76269 10.3547 2.65243 11.1851 3.6261 11.6766L4.44869 12.0664L3.47501 12.0834C2.53491 12.0834 2.50134 12.1003 2.60206 12.4562C2.93781 13.5578 4.26403 14.7273 5.74133 15.2357L6.78215 15.5916L5.87563 16.1339C4.53263 16.9136 2.9546 17.3542 1.37658 17.3881C0.621138 17.4051 0 17.4728 0 17.5237C0 17.6932 2.04808 18.6423 3.23999 19.0151C6.81573 20.1167 11.063 19.6422 14.2526 17.761C16.5189 16.4221 18.7852 13.7612 19.8428 11.1851C20.4136 9.81233 20.9844 7.30402 20.9844 6.10071C20.9844 5.3211 21.0347 5.21941 21.9748 4.28727C22.5288 3.74493 23.0492 3.15175 23.15 2.98227C23.3178 2.66025 23.3011 2.66025 22.4449 2.94837C21.018 3.45681 20.8165 3.38902 21.5216 2.62636C22.042 2.08402 22.6631 1.10103 22.6631 0.812917C22.6631 0.762073 22.4113 0.846813 22.1259 0.999345C21.8238 1.16883 21.1523 1.42305 20.6486 1.57558L19.7421 1.8637L18.9195 1.30441C18.4663 0.999345 17.8283 0.660385 17.4926 0.558696C16.6364 0.321424 15.327 0.35532 14.5548 0.626488C12.4563 1.38915 11.1301 3.35512 11.2812 5.50752Z"
                        fill="white"
                    />
                </svg>
            </a>

            <a href="http://linkedin.com/in/iamkeyiano">
                <svg width="16" height="15" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.31876 2.8227C6.31876 4.3918 5.13765 5.64735 3.24119 5.64735H3.20643C1.38045 5.64735 0.199997 4.3918 0.199997 2.8227C0.199997 1.2204 1.41641 0 3.27703 0C5.13765 0 6.28346 1.2204 6.31876 2.8227ZM5.96054 7.87785V24.2196H0.521614V7.87785H5.96054ZM25.5752 24.2196L25.5754 14.8497C25.5754 9.83026 22.8922 7.49411 19.3131 7.49411C16.4254 7.49411 15.1325 9.08025 14.4107 10.1929V7.87828H8.9711C9.04278 9.4117 8.9711 24.22 8.9711 24.22H14.4107V15.0934C14.4107 14.605 14.446 14.1178 14.5898 13.7681C14.9829 12.7924 15.8779 11.7822 17.3805 11.7822C19.3494 11.7822 20.1365 13.2807 20.1365 15.4767V24.2196H25.5752Z"
                        fill="white"
                    />
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
import { Intersection_observer } from '@/utils/observer'
const InputField = () => import('@/components/InputField')

export default {
    data() {
        return {
            identifier: '',
            formData: {
                name: '',
                email: '',
                message: ''
            },
            isSubmitting: false,
            message: '',
            messageType: ''
        }
    },
    components: {
        InputField
    },
    mounted() {
        Intersection_observer(this.handleInteract, this.$el, 0.8)
    },
    methods: {
        async handleInteract(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.$store.dispatch('SET_CURRENT_SECTION', 'contact')
                }
            })
        },
        highlighted(value) {
            this.identifier = value
        },
        updateField(field, event) {
            this.formData[field] = event.target.value
        },
        async submitForm() {
            // Clear previous messages
            this.message = ''
            this.messageType = ''
            
            // Validate form
            if (!this.validateForm()) {
                return
            }

            this.isSubmitting = true

            try {
                const response = await fetch('https://formspree.io/f/mpwywgra', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        name: this.formData.name,
                        email: this.formData.email,
                        message: this.formData.message
                    })
                })

                if (response.ok) {
                    this.message = 'Thank you for reaching out! I will get back to you soon.'
                    this.messageType = 'success'
                    this.resetForm()
                } else {
                    throw new Error('Failed to send message')
                }
            } catch (error) {
                console.error('Error sending message:', error)
                this.message = 'Sorry, there was an error sending your message. Please try again.'
                this.messageType = 'error'
            } finally {
                this.isSubmitting = false
            }
        },
        validateForm() {
            if (!this.formData.name.trim()) {
                this.message = 'Please enter your name.'
                this.messageType = 'error'
                return false
            }
            
            if (!this.formData.email.trim()) {
                this.message = 'Please enter your email address.'
                this.messageType = 'error'
                return false
            }
            
            // Basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.formData.email)) {
                this.message = 'Please enter a valid email address.'
                this.messageType = 'error'
                return false
            }
            
            if (!this.formData.message.trim()) {
                this.message = 'Please enter your message.'
                this.messageType = 'error'
                return false
            }
            
            return true
        },
        resetForm() {
            this.formData = {
                name: '',
                email: '',
                message: ''
            }
            // Reset form inputs
            const inputs = this.$refs.contactForm.querySelectorAll('input, textarea')
            inputs.forEach(input => {
                input.value = ''
            })
        }
    }
}
</script>

<style lang="scss">
.contactMe {
    min-height: 100vh;
    width: 100%;
    background-color: $tertiary;
    position: relative;

    h2 {
        font-size: 50px;
        color: white;
        .change_color {
            color: $primary !important;
        }
    }

    .container {
        width: 60%;
        .inputs_flex {
            width: 100%;
            margin-bottom: 3rem;
            .input_wrapper {
                width: 45%;
                input {
                    width: 100%;
                }
                position: relative;
            }
        }
        .button_wrapper {
            width: 60%;
            margin: 0 auto;
            margin-top: 2rem;
            // cursor: pointer;
            .contact_btn {
                border: 1px solid $primary;
                color: $primary;
                background: transparent;
                padding: 15px;
                width: 100%;
                margin: 0 auto;
                font-size: 20px;
                transition: 500ms;
            }
        }
    }

    .social_icons{
        position: absolute;
        bottom: 1%;
        width: 80%;
    }

    .message {
        margin-top: 1rem;
        padding: 1rem;
        border-radius: 4px;
        text-align: center;
        font-size: 16px;
        
        &.success {
            background-color: rgba(76, 175, 80, 0.1);
            color: #4CAF50;
            border: 1px solid #4CAF50;
        }
        
        &.error {
            background-color: rgba(244, 67, 54, 0.1);
            color: #f44336;
            border: 1px solid #f44336;
        }
    }
}

.contact_btn:hover {
    color: white !important;
    background: $primary !important;
    cursor: pointer;
}

@media screen and (max-width: 500px) {
    h2 {
        font-size: 40px !important;
        text-align: center;
    }

    .inputs_flex {
        flex-wrap: wrap;
        .input_wrapper {
            width: 100% !important;
        }

        .mb_3_sm {
            margin-bottom: 3rem;
        }
    }
}
</style>
